import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import ShippingRates from './ShippingRates';

const ShippingForm = ({ formData, handleChange }) => {
  // Helper function to handle country/region changes
  const handleCountryChange = (val) => {

    handleChange({ target: { name: 'country', value: val }});
    // Reset shipping method when country changes
    handleChange({ target: { name: 'shippingMethod', value: '' }});
  };

  const handleRegionChange = (val) => {
    handleChange({ target: { name: 'province', value: val }});
  };

  const handleShippingSelect = (rate) => {
    handleChange({ 
      target: { 
        name: 'shippingMethod', 
        value: { 
          code: rate.code,
          service: rate.service,
          rate: rate.rate 
        }
      }
    });
  };

  return (
    <div className="space-y-4 border rounded-lg p-4 mb-6 bg-white">
      <h3 className="text-lg font-semibold mb-4">Shipping Information</h3>
      {/* Personal Information */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block mb-2">First Name*</label>
          <input 
            type="text" 
            name="firstName"
            value={formData.firstName || ''}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
          />
        </div>
        <div>
          <label className="block mb-2">Last Name*</label>
          <input 
            type="text" 
            name="lastName"
            value={formData.lastName || ''}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block mb-2">Email*</label>
          <input 
            type="email" 
            name="email"
            value={formData.email || ''}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
          />
        </div>
        <div>
          <label className="block mb-2">Phone Number*</label>
          <input 
            type="tel"
            name="phone"
            value={formData.phone || ''}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
            placeholder="+1 (123) 456-7890"
          />
        </div>
      </div>

      {/* Address Information */}
      <div>
        <label className="block mb-2">Street Address*</label>
        <input 
          type="text"
          name="streetAddress"
          value={formData.streetAddress || ''}
          onChange={handleChange}
          required
          className="w-full border p-2 rounded"
          placeholder="123 Main St"
        />
      </div>

      <div>
        <label className="block mb-2">Apartment/Suite</label>
        <input 
          type="text"
          name="apartment"
          value={formData.apartment || ''}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          placeholder="Apt 4B (optional)"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block mb-2">Country*</label>
          <CountryDropdown
            value={formData.country || ''}
            onChange={handleCountryChange}
            classes="w-full border p-2 rounded"
            priorityOptions={['CA', 'US', 'GB', 'FR', 'DE']}
            whitelist={[
              'CA', 'US', 'FR', 'DE', 'IE', 'MX', 'ES', 'GB', 'AR', 'AU', 
              'AW', 'AM', 'AT', 'BE', 'BR', 'CL', 'CO', 'CR', 'HR', 'DK', 
              'DJ', 'SV', 'FI', 'GR', 'HU', 'IS', 'IL', 'IT', 'JP', 'KE', 
              'NL', 'NZ', 'NO', 'PE', 'PH', 'PL', 'PT', 'ZA', 'SE', 'CH', 'VE'
            ]}
          />
        </div>
        <div>
          <label className="block mb-2">City*</label>
          <input 
            type="text"
            name="city"
            value={formData.city || ''}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block mb-2">State/Province/Region*</label>
          <RegionDropdown
            country={formData.country || ''}
            value={formData.province || ''}
            onChange={handleRegionChange}
            classes="w-full border p-2 rounded"
          />
        </div>
        <div>
          <label className="block mb-2">Postal/ZIP Code*</label>
          <input 
            type="text"
            name="postalCode"
            value={formData.postalCode || ''}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
          />
        </div>
      </div>

      {/* Shipping Rates */}
      {formData.country && (
        <ShippingRates
          country={formData.country}
          selectedRate={formData.shippingMethod}
          onShippingSelect={handleShippingSelect}
        />
      )}
    </div>
  );
};

export default ShippingForm;